module.exports = __webpack_public_path__ + "img/photosession_1_10.3d5f6c9f.jpg";